import React, {FunctionComponent, useContext, useState, useEffect} from 'react';
import {ChallengeRegistrationData, Currency} from "/src/domain/challenges/ChallengeRegistrationData";
import {PageContext, PageContextProps} from "/src/contexts/Page";
import { ChallengeUser } from "/src/domain/challenges/ChallengeUser";
import { defaultAdditionalProfileData, AdditionalProfileData, getAdditionalProfileData } from "/src/ui/challengesRegistration/registrationForm/AdditionalProfileDataFields";
import { trimName } from '/src/domain/shared/trimName';
import { useTranslation } from 'react-i18next';

export interface ChallengeRegistrationContextProps {
    setCurrency: (newCurrency: Currency) => void;
    currency: Currency;
    setEmail: React.Dispatch<React.SetStateAction<string>>;
    email: string;
    additionalProfileData: AdditionalProfileData;
    setAdditionalProfileData: React.Dispatch<React.SetStateAction<AdditionalProfileData>>;
}


export const ChallengeRegistrationContext = React.createContext<ChallengeRegistrationContextProps | undefined>(undefined)


export const ChallengeRegistrationProvider: FunctionComponent = ({children}) => {
    const { t } = useTranslation();

    const {pageData, currentUser} = useContext(
        PageContext
    ) as PageContextProps;

    const challengeUser = currentUser as ChallengeUser | undefined;

    const challengeData = pageData as ChallengeRegistrationData;
    const [currency, setCurrency] = useState(challengeData?.payment?.currency ?? Currency.RUB);
    const [email, setEmail] = useState<string>(challengeUser?.email || '');
    const [additionalProfileData, setAdditionalProfileData] = useState<AdditionalProfileData>(defaultAdditionalProfileData);

    const parseProfileData = () => {
        setAdditionalProfileData(getAdditionalProfileData(challengeUser));
    };

    useEffect(() => {
        parseProfileData();
    }, [challengeUser]);

    return (
        <ChallengeRegistrationContext.Provider
            value={{
                setCurrency,
                currency,
                setEmail,
                email,
                additionalProfileData,
                setAdditionalProfileData,
            }}>{children}
        </ChallengeRegistrationContext.Provider>
    );
}
